import authService from "../services/authServices";
import { useMutation } from "react-query";


const useCompanyExistMutation = (onData) => {
    return useMutation(authService.companyExist, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useDocExistMutation = (onData) => {
    return useMutation(authService.docExist, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useVesselListMutation = (onData) => {
    return useMutation(authService.vesselList, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useDocListMutation = (onData) => {
    return useMutation(authService.docList, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useCategoryListMutation = (onData) => {
    return useMutation(authService.categoryList, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useOtpCheckMutation = (onData) => {
    return useMutation(authService.OTPcheck, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useOtpVerifyMutation = (onData) => {
    return useMutation(authService.OTPverify, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useCompliantMutation = (onData) => {
    return useMutation(authService.Compliant, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useCodeUploadMutation = (onData) => {
    return useMutation(authService.CodeFileUpload, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useNoCodeUploadMutation = (onData) => {
    return useMutation(authService.NoCodeFileUpload, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useShipTypeMutationList = (onData) => {
    return useMutation(authService.shipType, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useRankOnBoardMutation = (onData) => {
    return useMutation(authService.rankOnBoard, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useComplaintWithOutCodeMutation = (onData) => {
    return useMutation(authService.complaintWithOutCode, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useSurveyMutation = (onData) => {
    return useMutation(authService.survey, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};


const authQueries = {
    useCompanyExistMutation,
    useDocExistMutation,
    useVesselListMutation,
    useDocListMutation,
    useCategoryListMutation,
    useOtpCheckMutation,
    useOtpVerifyMutation,
    useCompliantMutation,
    useCodeUploadMutation,
    useNoCodeUploadMutation,
    useShipTypeMutationList,
    useRankOnBoardMutation,
    useComplaintWithOutCodeMutation,
    useSurveyMutation,
};

export default authQueries